import {FormEditor} from "@t/fd/editor/FormEditor.ts";
import {InternetAddress} from "@t/mail/InternetAddress.ts";

export const SUGGESTIONS_LIMIT = 20;

/** This is select dedicated to pick users, groups or non-user parties */
export interface MailSelect extends FormEditor {
	type: "mail-select";
	/** Placeholder string on empty selection */
	placeholder?: string;
	/** Minimum number of selected categories (default is 0) */
	min?: number;
	/** Maximum number of selected categories (default is unlimited) */
	max?: number;
}

export interface SuggestedMail {
	/** Opaque suggestion ID */
	id: string;

	/*ID of trinity*/
	customer?: number; 
	branch?: number;
	person?: number;

	/** Suggestion label, can be empty (one address without personal info) */
	name?: string;
	/** Suggested emails */
	mails: InternetAddress[];

	/** Icon for the suggestion row */
	icon: string;
}

/**
 * This is the declaration of response from the suggester used by UserSelect component
 */
export interface MailResponse {
	mails: SuggestedMail[];
}